import { createRoot } from "react-dom/client";
import "./i18n";
import "@fontsource/fraunces/600.css";
import "@fontsource/fraunces/700.css";
import "@fontsource/literata/600.css";
import "@fontsource/literata/700.css";
import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/600.css";
import "@fontsource/inter/700.css";
import "@fontsource/barlow-semi-condensed/500.css";
import "@fontsource/barlow-semi-condensed/600.css";
import "@bd/ui-kit/styles.css";
import "./app.css";
import { App } from "./App";
import { host, useGame } from "./store";
import { furnitureGhostValid } from "./world/World";

// test and debugging hooks (Playwright drives the game through these)
(window as unknown as { __bd: unknown }).__bd = { host, useGame, furnitureGhostValid };

createRoot(document.getElementById("root")!).render(<App />);
